import {
  RouteConfig
} from 'vue-router'
import Layout from '@/layout/index.vue'

const activityRouter: RouteConfig[] = [
  {
    path: '/activity',
    component: Layout,
    name: 'activity',
    redirect: '/activity/activity-list',
    meta: {
      title: '活动管理'
    },
    children: [
      {
        path: 'activity-list',
        name: 'ActivityList',
        component: () => import(/* webpackChunkName: "Activity" */ '@/views/activity/activity/list.vue'),
        meta: {
          title: '活动维护'
        }
      },
      {
        path: 'detail/:id?',
        name: 'ActivityDetail',
        component: () => import(/* webpackChunkName: "ActivityDetail" */ '@/views/activity/activity-detail.vue'),
        meta: {
          title: '活动详情'
        }
      },
      {
        path: 'activity/edit/:id',
        name: 'ActivityEdit',
        component: () => import(/* webpackChunkName: "ActivityEdit" */'@/views/activity/activity/edit.vue'),
        meta: {
          title: '活动发布'
        }
      },
      {
        path: "activity/checkIn/:id?",
        name: "ActivityCheckIn",
        component: () => import(/* webpackChunkName: "ActivityCheckIn" */ '@/views/activity/activity/checkIn.vue'),
        meta: {
          title: "报名签到"
        }
      },
      {
        path: "apply/list/:activityId?",
        name: "ActivityApplyList",
        component: () => import(/* webpackChunkName: "ActivityApplyList" */ '@/views/activity/apply/list.vue'),
        meta: {
          title: "活动订单"
        },
        children:[
          {
            path: 'apply/:id?',
            name: 'ActivityApplyDetail',
            component: () => import(/* webpackChunkName: "ActivityApplyDetail" */ '@/views/activity/apply/detail.vue'),
            meta: {
              title: '报名详情'
            }
          }
        ]
      },

    ]
  }
]


export default activityRouter;
